import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { ColorService } from '../services/color.service';
import { Color } from '../models/color.model';

@Component({
    selector: 'ng-color-form',
    templateUrl: 'color-form.component.html'
})

export class ColorFormComponent extends BaseFormComponent<Color> {

    constructor(protected injector: Injector, protected colorServ: ColorService) {
        super(injector, 'color', '/admin/settings/color', Color.fromJsonToObject, colorServ);
    }

    protected buildForm(): void {
        this.objectForm = this.formBuilder.group({
            description: this.formBuilder.control(null, [Validators.required]),
            id: this.formBuilder.control(null),
        })
    }

    protected initChildProprieties(): void { }
    protected initChildMethods(): void { }
}